import React from 'react';
import FeatureImg from '../assets/img/feature/intro-mobile.png';
const Features = () => {
  return (
    <section id="features" className="section-padding">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title lang-en">Awesome Features</h2>
          <h2 className="section-title lang-ar" style={{ display: 'none' }}>المميزات الرائعة</h2>
          <div className="shape"></div>
        </div>

        <div className="row">
          <div className="col-lg-4">
            <div className="content-left">
              <div className="box-item">
                <span className="icon"><i className="lni-rocket"></i></span>
                <div className="text">
                  <h4 className="lang-en">Smart Management</h4>
                  <h4 className="lang-ar" style={{ display: 'none' }}>نظام إدارة ذكي</h4>
                  <p className="lang-en">Control orders, staff and inventory from one dashboard.</p>
                  <p className="lang-ar" style={{ display: 'none' }}>تحكم كامل في الطلبات، الموظفين، والمخزون من لوحة تحكم واحدة.</p>
                </div>
              </div>

              <div className="box-item">
                <span className="icon"><i className="lni-laptop-phone"></i></span>
                <div className="text">
                  <h4 className="lang-en">Fully Responsive</h4>
                  <h4 className="lang-ar" style={{ display: 'none' }}>يدعم جميع الأجهزة</h4>
                  <p className="lang-en">Works on mobile, tablet and desktop.</p>
                  <p className="lang-ar" style={{ display: 'none' }}>المنصة متوافقة مع الجوال والتابلت والكمبيوتر.</p>
                </div>
              </div>

              <div className="box-item">
                <span className="icon"><i className="lni-cog"></i></span>
                <div className="text">
                  <h4 className="lang-en">Customizable</h4>
                  <h4 className="lang-ar" style={{ display: 'none' }}>قابل للتخصيص</h4>
                  <p className="lang-en">Roles, points, and inventory adapted to your needs.</p>
                  <p className="lang-ar" style={{ display: 'none' }}>خصص صلاحيات المستخدمين، النقاط، والمخزون حسب احتياجك.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 text-center">
            <div className="show-box">
              <img src={FeatureImg} alt="Features" className="img-fluid" />
            </div>
          </div>

          <div className="col-lg-4">
            <div className="content-right">
              <div className="box-item">
                <span className="icon"><i className="lni-leaf"></i></span>
                <div className="text">
                  <h4 className="lang-en">Modern UI/UX</h4>
                  <h4 className="lang-ar" style={{ display: 'none' }}>تصميم عصري وسهل</h4>
                  <p className="lang-en">Intuitive interface for fast adoption.</p>
                  <p className="lang-ar" style={{ display: 'none' }}>واجهة بسيطة لتجربة استخدام سريعة.</p>
                </div>
              </div>

              <div className="box-item">
                <span className="icon"><i className="lni-layers"></i></span>
                <div className="text">
                  <h4 className="lang-en">Multi kitchens & branches</h4>
                  <h4 className="lang-ar" style={{ display: 'none' }}>يدعم تعدد الفروع والمطابخ</h4>
                  <p className="lang-en">Manage multiple kitchens or branches from one system.</p>
                  <p className="lang-ar" style={{ display: 'none' }}>إدارة عدة مطابخ أو فروع من نظام مركزي واحد.</p>
                </div>
              </div>

              <div className="box-item">
                <span className="icon"><i className="lni-envelope"></i></span>
                <div className="text">
                  <h4 className="lang-en">Real-time Notifications</h4>
                  <h4 className="lang-ar" style={{ display: 'none' }}>إشعارات فورية</h4>
                  <p className="lang-en">Push notifications for orders, points and updates.</p>
                  <p className="lang-ar" style={{ display: 'none' }}>إشعارات مباشرة للطلبات والنقاط والتحديثات.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
